import {
  estAdministrateurGlobal,
  peutConsulterInstallation,
} from '../../Services/droits-installations';
import { Component, computed, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';
import { Authentification } from '../../Services/authentification';
import { EtatService } from '../../Services/etat';

@Component({
  selector: 'app-menu',
  imports: [RouterLink, NgOptimizedImage],
  templateUrl: './menu.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './menu.css',
})
export class Menu {
  private readonly etat = inject(EtatService);
  private readonly router = inject(Router);
  private readonly auth = inject(Authentification);
  menuMobileOuvert = signal(false);
  readonly accesMetier = computed(() => peutConsulterInstallation(this.auth.tokenInfoSignal()));
  readonly administration = computed(() => estAdministrateurGlobal(this.auth.tokenInfoSignal()));
  nombreInterventionsAVenir = this.etat.nombreInterventionsAVenir;
  tooltipInterventions = computed(() => {
    const nombre = this.nombreInterventionsAVenir();
    if (nombre === 0) return 'Aucune intervention à venir';
    return `${nombre} intervention${nombre > 1 ? 's' : ''} à venir`;
  });

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        this.menuMobileOuvert.set(false);
      });
  }

  private idInstallationCourante(): number | null {
    const m = this.router.url.match(/\/installation\/(\d+)/);
    return m ? Number(m[1]) : null;
  }

  lienDashboard(): (string | number)[] {
    const id = this.idInstallationCourante();
    return id != null ? ['/installation', id] : ['/parc'];
  }

  lienTickets(): (string | number)[] {
    const id = this.idInstallationCourante();
    return id != null ? ['/installation', id, 'tickets'] : ['/tickets'];
  }

  lienGraphiques(): (string | number)[] {
    const id = this.idInstallationCourante();
    return id != null ? ['/installation', id, 'graphiques'] : ['/graphiques'];
  }

  lienMateriel(): (string | number)[] {
    const id = this.idInstallationCourante();
    return id != null ? ['/installation', id, 'materiel'] : ['/materiel'];
  }

  isDashboardActif(): boolean {
    return this.isActive('/parc') || /\/installation\/\d+$/.test(this.router.url);
  }

  toggleMenuMobile(): void {
    this.menuMobileOuvert.set(!this.menuMobileOuvert());
  }

  seDeconnecter(): void {
    this.auth.logOut();
  }

  /**
   * Determines if the given URL is currently active.
   * @param url - The URL to check.
   * @returns true if the current route matches the given URL, false otherwise.
   */
  isActive(url: string): boolean {
    const exp = new RegExp(url);
    const res = this.router.url.match(exp);
    return res && res != null ? true : false;
  }
}
